import React from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Box,
	Typography,
} from '@mui/material'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import { SeasonType } from '@schemas'
import { mono } from '@components/systems/backoffice/backoffice.tokens'
import dayjs from 'dayjs'

interface PropsType {
	open: boolean
	/** 지금 판매중인 시즌. 없으면 전환이 아니라 첫 판매 시작이다. */
	currentSeason: SeasonType | null
	targetSeason: SeasonType | null
	onCancel: () => void
	onConfirm: () => void
}

const SeasonSummary = (props: { label: string; season: SeasonType | null }) => (
	<Box sx={{ display: 'flex', gap: 2, alignItems: 'baseline' }}>
		<Typography sx={{ width: '5rem', color: mono.dim, flexShrink: 0 }}>
			{props.label}
		</Typography>
		<Box>
			<Typography sx={{ fontWeight: 500 }}>{props.season?.title ?? '없음'}</Typography>
			{props.season && (
				<Typography variant="body2" sx={{ color: mono.dim }}>
					{dayjs(props.season.startDate).format('YYYY-MM-DD')} ~{' '}
					{dayjs(props.season.endDate).format('YYYY-MM-DD')}
				</Typography>
			)}
		</Box>
	</Box>
)

/**
 * 판매 시즌 전환 확인.
 *
 * 이미 판매중인 시즌이 있을 때만 띄운다. 전환은 서버에서 한 트랜잭션으로 처리되므로
 * 두 시즌이 동시에 열리는 순간은 없다.
 */
export const SeasonOpenConfirmationModal = (props: PropsType) => {
	const { open, currentSeason, targetSeason, onCancel, onConfirm } = props
	const isSwitching = currentSeason !== null

	return (
		<Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
			<DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<SwapHorizIcon sx={{ color: mono.dim, fontSize: 20 }} />
				{isSwitching ? '판매 시즌을 변경합니다' : '판매를 시작합니다'}
			</DialogTitle>

			<DialogContent>
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
					{isSwitching && <SeasonSummary label="현재" season={currentSeason} />}
					<SeasonSummary label={isSwitching ? '변경 후' : '대상'} season={targetSeason} />
				</Box>

				<Box component="ul" sx={{ pl: 2, m: 0, color: mono.dim, lineHeight: 1.9 }}>
					{isSwitching && <li>{currentSeason?.title}은(는) 자동으로 판매 중지됩니다</li>}
					<li>고객 장바구니의 이전 시즌 상품은 비워집니다</li>
					<li>shop 에 즉시 반영됩니다</li>
				</Box>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={onCancel} color="inherit">
					취소
				</Button>
				<Button onClick={onConfirm} variant="contained">
					{isSwitching ? '전환' : '판매 시작'}
				</Button>
			</DialogActions>
		</Dialog>
	)
}
